import { DistributeReq, DistributeDef, TrendReq, TrendDef } from "./type/trend";
import { HeatmapDef, RankingDef, AssetReq, LayerDef } from "./type/asset";
import { DemographyReq, DemographyDef } from "./type/demography";
import { KpiAttrDef, KpiReq, KpiDef } from "./type/kpi";

import { DistributeAdapter } from "./adapter/trend/distribute";
import { RankingAdapter } from "./adapter/asset/ranking";
import { HeatmapAdapter } from "./adapter/asset/heatmap";
import { DemographyAdapter } from "./adapter/demography";
import { LayerAdapter } from "./adapter/asset/layer";
import { TrendAdapter } from "./adapter/trend/trend";
import { KpiAdapter } from "./adapter/kpi";

import { IDashboardRepo } from "./irepo";

import { TError } from "../../types/error";

export class DashboardUsecase {
  private repo: IDashboardRepo;
  private error: (error: TError) => void;

  constructor(repo: IDashboardRepo, error: (error: TError) => void) {
    this.repo = repo;
    this.error = error;
  }

  async fetchDemography(req: DemographyReq): Promise<DemographyDef> {
    try {
      const dto = DemographyAdapter.toInputDTO(req);
      const data = await this.repo.fetchDemography(dto);
      return DemographyAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: "dashboard", error });
      throw error;
    }
  }

  async fetchTrend(req: TrendReq): Promise<TrendDef> {
    try {
      const dto = TrendAdapter.toInputDTO(req);
      const data = await this.repo.fetchTrend(dto);
      return TrendAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: "dashboard", error });
      throw error;
    }
  }

  async fetchDistribute(req: DistributeReq): Promise<DistributeDef> {
    try {
      const dto = DistributeAdapter.toInputDTO(req);
      const data = await this.repo.fetchDistribute(dto);
      return DistributeAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: "dashboard", error });
      throw error;
    }
  }

  async fetchKpiAttrs(): Promise<KpiAttrDef> {
    try {
      return await this.repo.fetchKpiAttrs();
    } catch (error) {
      this.error({ id: "dashboard", error });
      throw error;
    }
  }

  async updateKpiAttrs(req: KpiReq): Promise<any> {
    try {
      const dto = KpiAdapter.toInputDTO(req);
      return await this.repo.updateKpiAttrs(dto);
    } catch (error) {
      this.error({ id: "dashboard", error });
      throw error;
    }
  }

  async fetchKpi(): Promise<KpiDef> {
    try {
      const data = await this.repo.fetchKpi();
      return KpiAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: "dashboard", error });
      throw error;
    }
  }

  async fetchLayer(): Promise<LayerDef> {
    try {
      const data = await this.repo.fetchLayer();
      return LayerAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: "dashboard", error });
      throw error;
    }
  }

  async fetchRanking(req: AssetReq): Promise<RankingDef> {
    try {
      const dto = RankingAdapter.toInputDTO(req);
      const data = await this.repo.fetchRanking(dto);
      return RankingAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: "dashboard", error });
      throw error;
    }
  }

  async fetchHeatmap(): Promise<HeatmapDef> {
    try {
      const data = await this.repo.fetchHeatmap();
      return HeatmapAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: "dashboard", error });
      throw error;
    }
  }
}
